import {fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import { appConfig } from '../../../config/app-config';
import { RootState } from '@/store';


export const baseQuery = fetchBaseQuery({
  baseUrl: appConfig[`baseUrl${import.meta.env.VITE_APP_ENV}`],
  prepareHeaders: (headers, {getState}) => {
    const token = (getState() as RootState).auth.token;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});
